import { useCallback } from "react";

import { isNil } from "lodash";

import { Action, ActionType } from "types/graphql";

interface Props {
  allowedActions: Action[];
}

export interface ActionConfig {
  isActionAllowed: boolean;
  isExternal?: boolean;
  type?: ActionType;
  externalUrl?: string | null;
}

export const useAllowedActions = ({ allowedActions }: Props) => {
  const getActionConfig = useCallback(
    (actionType: ActionType, allowByDefault = true): ActionConfig => {
      // Null actions indicate legacy Flatbook, no permissions available
      if (isNil(allowedActions)) {
        return {
          isActionAllowed: allowByDefault,
        };
      }

      const action = allowedActions.find(ac => ac.type === actionType);

      if (!action) {
        return {
          isActionAllowed: false,
        };
      }

      return {
        isActionAllowed: true,
        isExternal: !!action.externalUrl,
        ...action,
      };
    },
    [allowedActions],
  );

  return { getActionConfig };
};
